
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

export type ExclamationIconShape = 'circle' | 'triangle';

/** Additional input: `direction:'horizontal'|'vertical' = 'horizontal'` for ellipsis direction. */
@Component({
  selector: 'icon-exclamation',
  imports: [],
  templateUrl: './exclamation-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExclamationIconComponent extends BaseIconComponent {
  readonly shape = input<ExclamationIconShape>('triangle');
}
